import { SERVER_URL } from "../../api";
import axios from 'axios'
import { getHeaderWithToken } from "../../helpers/func";
export const DELETE_STITCH_REQUEST = 'DELETE_STITCH_REQUEST';
export const DELETE_STITCH_SUCCESS = 'DELETE_STITCH_SUCCESS';
export const DELETE_STITCH_ERROR = 'DELETE_STITCH_ERROR';
export const RESET_DELETE_STITCH = 'RESET_DELETE_STITCH';


export const deleteStitch = (data) => {
    let headers = getHeaderWithToken();
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: DELETE_STITCH_REQUEST
            })
            axios({
                method: 'DELETE',
                url: `${SERVER_URL}v1/pattern/stitch/${data}`,
                headers: headers
            }).then(function (response) {
                dispatch({
                    type: DELETE_STITCH_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: DELETE_STITCH_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }
}



